<template>
    <v-flex v-if="value">
        <v-btn :href="addressLink"
               target="_blank"
               @click="preventParentBehaviour"
        >
            <v-icon>mail</v-icon>
        </v-btn>
    </v-flex>
</template>

<script>
/**
 * Outputs a link for a gift voucher's address for mailing
 */
export default {
    name: 'ies-voucher-address-link',
    props: ['field', 'value'],
    data () {
        return {}
    },

    methods: {
        getUrl: function(){
            return "/vouchers-to-post/" + this.value;
        },

        /**
         * Attempt to prevent default behaviours in parent components
         */
        preventParentBehaviour: function(e){
            console.log(e);
            //e.preventDefault();
            e.stopPropagation();    
        }
    },

    computed: {
        addressLink: function(){
            return this.getUrl();
        },
    }
}
</script>
